import { BrowserModule } from '@angular/platform-browser';
import { NgModule,APP_INITIALIZER ,DoBootstrap} from '@angular/core';
import { KeycloakAngularModule, KeycloakService } from 'keycloak-angular';
import {FormsModule} from '@angular/forms';
import { HttpClientModule } from '@angular/common/http'; 
import { AppComponent } from './app.component';
import { LoginComponent } from './login.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DropdownModule } from 'primeng/dropdown';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RatingModule } from 'primeng/rating';
import { InputTextModule } from 'primeng/inputtext';
import { SelectButtonModule } from 'primeng/selectbutton';
import { DialogModule } from 'primeng/dialog';
import { AppRoutingModule } from './app-routing.module';
import { PlayerComponent } from './player/player.component';
import { initKeycloakForRealm, isLoginRoute, resolveRealm } from './auth-realm';
import { AppRootComponent } from './app-root.component';
function initializeKeycloak(keycloak: KeycloakService) {
  return async () => { 
    if (isLoginRoute()) {
      return true;
    }

    const realm = resolveRealm();
    if (!realm) {
      return true;
    }

    try {
      await initKeycloakForRealm(keycloak, realm);
    } catch (err) {
      console.error('Keycloak init failed:', err);
    }

    return true;
  };
}




@NgModule({
  declarations: [
    AppComponent,
    AppRootComponent,
    PlayerComponent,
    LoginComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FontAwesomeModule,
    FormsModule,
    NgbModule,
    DropdownModule,
    RatingModule,
    InputTextModule,
    SelectButtonModule,
    KeycloakAngularModule,
    AppRoutingModule,
    DialogModule
    
  
    
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initializeKeycloak,
      multi: true,
      deps: [KeycloakService],
    },
  ],
  bootstrap: [AppRootComponent],
})


export class AppModule {}
